/**
 * CORE-G GAP-005 — "one name, one meaning". Two different efficiency figures exist and must never share a bare
 * "Efficiency" label:
 *
 *   planning   `technicians.efficiency_percentage` — the rate scheduling plans with (learned by CORE-AN, set by a
 *              person, or imported; its basis is disclosed by EfficiencyBasisBadge). It changes wall-clock plans.
 *   bookTime   `technician_performance_metrics.avg_efficiency_book` — completed work measured against book time, a
 *              performance (KPI) average over a period. It never schedules anything.
 *
 * Every surface that renders one of them names it from this vocabulary (pinned by
 * tests/unit/core100/efficiencyOneNameOneMeaning.test.ts).
 */
export const EFFICIENCY_NAMES = {
  planning: {
    label: 'Planning efficiency',
    short: 'Planning eff.',
    scope: 'The rate this technician is scheduled with (technicians.efficiency_percentage).',
  },
  bookTime: {
    label: 'Book-time efficiency',
    short: 'Book-time eff.',
    scope: 'Completed work measured against book time, averaged over the period (a performance figure; never used to schedule).',
  },
} as const;
